<template>
    <div class="home">

        <HeroBanner />
        
        <!-- Signup Modal -->
        <SignupModal 
            :show="showSignupModal" 
            @close="showSignupModal = false"
            @switch-to-signin="handleSignInRequest"
        />
        
        <!-- Sign In Modal -->
        <SignInModal 
            :show="showSignInModal" 
            @close="showSignInModal = false"
            @switch-to-signup="handleSignUpRequest"
        />
        <AllGames />
        <PopularGames />
        <Bets />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import HeroBanner from '@/components/HeroBanner';
    import SignupModal from '@/components/SignupModal.vue';
    import SignInModal from '@/components/SignInModal.vue';
    import PopularGames from '@/components/PopularGames';
    import AllGames from '@/components/AllGames';
    import Bets from '@/components/bets/Bets';

    export default {
        name: 'Home',
        metaInfo: {
            title: 'Worldcupsports.casino - Premium Online Gaming Platform'
        },
        components: {
            HeroBanner,
            SignupModal,
            SignInModal,
            PopularGames,
            AllGames,
            Bets
        },
        data() {
            return {
                showSignupModal: false,
                showSignInModal: false
            }
        },
        computed: {
            ...mapGetters(['authUser'])
        },
        methods: {
            formatBalance(value) {
                return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
            handlePlayNowClick() {
                // If user is not logged in, show sign in modal
                if (this.authUser.user === null) {
                    this.showSignInModal = true;
                } else {
                    // If user is logged in, navigate to Our Casino page
                    this.$router.push('/our-casino');
                }
            },
            handleSignInRequest() {
                this.showSignupModal = false;
                this.showSignInModal = true;
            },
            handleSignUpRequest() {
                this.showSignInModal = false;
                this.showSignupModal = true;
            }
        },
        mounted() {
            // Listen for sign in modal requests from Header
            this.$root.$on('open-signin-modal', this.handleSignInRequest);
            this.$root.$on('open-signup-modal', this.handleSignUpRequest);
        },
        beforeDestroy() {
            this.$root.$off('open-signin-modal', this.handleSignInRequest);
            this.$root.$off('open-signup-modal', this.handleSignUpRequest);
        },
        errorCaptured(err, vm, info) {
            console.error('Home page component error:', err, info);
            // Return false to stop the error from propagating
            return false;
        }
    }
</script>

<style scoped>
    .home {
        width: 100%;
        min-height: 100vh;
       /* padding-top: 50px; */
    }

    .balance-container {
        width: 100%;
        padding: 12px 100px 0 100px;
        margin-bottom: 16px;
        display: none; /* Hidden by default on desktop */
    }

    .balance-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 24px;
        background: linear-gradient(135deg, rgba(26, 26, 46, 0.95) 0%, rgba(45, 45, 68, 0.95) 100%);
        border: 2px solid var(--accent-yellow);
        border-radius: 16px;
        backdrop-filter: blur(10px);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
        max-width: 400px;
    }

    .balance-info {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .balance-label {
        font-size: 12px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.7);
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .balance-amount {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .balance-amount svg {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
    }

    .amount-value {
        font-size: 24px;
        font-weight: 800;
        color: #ffffff;
        text-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
    }

    .deposit-btn {
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--gradient-button-bg);
        border: 1px solid var(--accent-yellow);
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.3s ease;
        color: var(--accent-btn-txt-color);
    }

    .deposit-btn:hover {
        transform: scale(1.05);
        box-shadow: 0 4px 16px rgba(255, 215, 0, 0.4);
    }

    .deposit-btn svg {
        width: 20px;
        height: 20px;
    }

    .live-feed-section {
        display: flex;
        gap: var(--spacing-xl);
        padding: var(--spacing-2xl) 0 var(--spacing-2xl) 0;
        margin: 0 21px 0 21px;
        align-items: center;
    }

    @media only screen and (max-width: 1200px) {
        .live-feed-section {
            flex-direction: column;
            margin: 0 var(--spacing-lg);
            display: block;
        }
    }

    @media only screen and (max-width: 768px) {
        .home {
            padding-top: 30px;
        }

        .balance-container {
            display: block; /* Show on mobile */
            padding: 12px var(--spacing-md) 0 var(--spacing-md);
            margin-bottom: 12px;
        }

        .balance-card {
            padding: 14px 18px;
            max-width: 100%;
        }

        .balance-label {
            font-size: 11px;
        }

        .balance-amount svg {
            width: 20px;
            height: 20px;
        }

        .amount-value {
            font-size: 20px;
        }

        .deposit-btn {
            width: 40px;
            height: 40px;
        }

        .deposit-btn svg {
            width: 18px;
            height: 18px;
        }

        .live-feed-section {
            margin: 0;
            padding: var(--spacing-xl) var(--spacing-md);
            gap: var(--spacing-lg);
            display: block;
        }
    }

    @media only screen and (max-width: 480px) {
        .home {
            padding-top: 20px;
        }

        .balance-container {
            padding: 10px 12px 0 12px;
            margin-bottom: 10px;
        }

        .balance-card {
            padding: 12px 16px;
        }

        .balance-label {
            font-size: 10px;
        }

        .balance-amount svg {
            width: 18px;
            height: 18px;
        }

        .amount-value {
            font-size: 18px;
        }

        .deposit-btn {
            width: 36px;
            height: 36px;
        }

        .deposit-btn svg {
            width: 16px;
            height: 16px;
        }
    }

</style>
